import { generateTestId } from "@client-shared";
import type { PurchaseOrder } from "@shared/types";

export const setCreateBatchDialogTestId = (identifier: string): string => generateTestId("CreateBatchDialog", identifier);

export function getTotalBatchUnits(orders: PurchaseOrder[]): number {
  const quantities = orders.flatMap(
    (po) =>
      po.lineItems?.map((li) => {
        const qty = Number.parseInt(String(li.quantity), 10);
        return Number.isNaN(qty) ? 0 : qty;
      }) ?? []
  );
  return quantities.length > 0 ? quantities.reduce((a, b) => a + b, 0) : 0;
}

export function getTotalBatchWeight(orders: PurchaseOrder[]): number {
  const weights = orders.flatMap((po) => po.lineItems?.map((li) => Number(li.lineItemWeightInGrams ?? 0)) ?? []);
  return weights.length > 0 ? weights.reduce((a, b) => a + b, 0) : 0;
}
